var render = function render(){var _vm=this,_c=_vm._self._c;return _c('item-characteristics',{attrs:{"item":_vm.item}})
}
var staticRenderFns = []

export { render, staticRenderFns }